import React, { useEffect, useState } from 'react';
import { Card, Col, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import { useGetPackageQuery } from '../../../app/services/chatbot-rtk.services';
import { MultiLanguageUrl } from '../../../constants/multiLanguage.constant';
import Dashboard from '../home/Dashboard';

function BillingCheckoutPage() {
  const { i18n, t } = useTranslation();
  const [skipGetClient, setSkipGetClient] = useState(true);

  useGetPackageQuery(undefined, {
    skip: skipGetClient,
  });

  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  // const planName = searchParams.get("plan_name");

  const navigate = useNavigate();

  useEffect(() => {
    setSkipGetClient(false);

    // if (status && status === "true" && planName) {
    //   const popunder = window.open(
    //     `${
    //       import.meta.env.VITE_UI_ADDRESS +
    //       `/en-US/welcome?plan_name=${planName}&status=true`
    //     }`,
    //     "newwindow",
    //     "toolbar=no,status=no,width=100,height=100"
    //   );

    //   window.focus();
    //   popunder?.blur();
    // }
  }, [status]);

  const [show] = useState(true);

  const handleClose = () => {
    navigate(`/${MultiLanguageUrl[i18n.language] || 'en-US'}/control-panel`, {
      replace: true,
    });
  };

  if (status == 'true') {
    return (
      <section>
        <Dashboard />
        {show && (
          <Modal show={show} centered onHide={handleClose}>
            <Modal.Body className="d-flex justify-content-center ">
              <Card className="  tw-w-[380px] tw-h-[448px]">
                <Card.Body className="tw-p-10">
                  <Row>
                    <Col className="text-center ">
                      <Row className="tw-mt-8">
                        <Col>
                          <div>
                            <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="44" cy="44" r="44" fill="#D9E2FB" />
                              <circle cx="44" cy="44" r="28" fill="#4167DA" />
                              <path
                                d="M39.9999 51.1719L33.4139 44.5859L30.5859 47.4139L39.9999 56.8279L59.4139 37.4139L56.5859 34.5859L39.9999 51.1719Z"
                                fill="#F0F4FF"
                              />
                            </svg>
                          </div>
                        </Col>
                      </Row>
                      <Row className="tw-mt-7">
                        <Col>
                          <h2 className="font-sofiaSans fw-bold">{t('BillingCheckoutPage/t-01')}</h2>
                        </Col>
                      </Row>
                      <Row className="tw-mt-2">
                        <Col className="tw-flex tw-justify-center">
                          <p className="fs-5 tw-w-[300px] font-sofiaSans tw-text-zinc-500 ">{t('BillingCheckoutPage/text-01')}</p>
                        </Col>
                      </Row>
                      <Row className="tw-mt-2">
                        <Col className="tw-flex tw-justify-center"></Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Modal.Body>
          </Modal>
        )}
      </section>
    );
  } else {
    return (
      <section>
        <Dashboard />
        <Modal show={true} centered onHide={handleClose}>
          <Modal.Body className="d-flex justify-content-center ">
            <Card className="  tw-w-[380px] tw-h-[448px]">
              <Card.Body className="tw-p-10">
                <Row>
                  <Col className="text-center ">
                    <Row className="tw-mt-8">
                      <Col>
                        <div>
                          <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="44" cy="44" r="44" fill="#EB4335" fillOpacity="0.12" />
                            <circle cx="44" cy="44" r="28" fill="#EB4335" />
                            <path
                              d="M52.3839 32.6875L43.8979 41.1715L35.4139 32.6875L32.5859 35.5155L41.0699 43.9995L32.5859 52.4835L35.4139 55.3115L43.8979 46.8275L52.3839 55.3115L55.2119 52.4835L46.7279 43.9995L55.2119 35.5155L52.3839 32.6875Z"
                              fill="#F0F4FF"
                            />
                          </svg>
                        </div>
                      </Col>
                    </Row>
                    <Row className="tw-mt-7">
                      <Col>
                        <h2 className="font-sofiaSans fw-bold">{t('BillingCheckoutPage/t-02')}</h2>
                      </Col>
                    </Row>
                    <Row className="tw-mt-2">
                      <Col className="tw-flex tw-justify-center">
                        <p className="fs-5 tw-w-[300px] font-sofiaSans tw-text-zinc-500 ">{t('BillingCheckoutPage/text-02')}</p>
                      </Col>
                    </Row>
                    <Row className="tw-mt-2">
                      <Col className="tw-flex tw-justify-center"></Col>
                    </Row>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Modal.Body>
        </Modal>
      </section>
    );
  }
}

export default WrappedErrorBoundary(BillingCheckoutPage);
